import { Box } from "@mui/material"
import Page from "components/Page"
import Projects from "components/Projects"
import Highlights from "components/Highlights"

const Works = () => {
  return (
    <Page id="works">
      <Box m={2}></Box>
      <Highlights/>
      <Box m={4}></Box>
      <Projects/>
    </Page>
  )
}

export default Works
